module.exports = __webpack_public_path__ + "img/datasource-data.b60b0cf3.png";